import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CloudbedsService } from '@app/services/cloudbeds.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-popup-message',
  templateUrl: './popup-message.component.html',
  styleUrls: ['./popup-message.component.scss'],
})
export class PopupMessageComponent implements OnInit {

  @Input() title: any;
  @Input() image: any;
  @Input() text: any;
  @Input() text2: any;
  @Input() text3: any;
  @Input() buttons: any;
  @Input() small: any;
  @Input() showList: any;
  @Input() upgrade: any;
  @Input() qrcode: any;
  @Input() reservationNumber: any;
  upgradeList: any;
  upgradeType: number;
  constructor(
    private modalCtrl: ModalController,
    public cloudbedService: CloudbedsService,
    private router: Router
  ) { }

  ngOnInit() {
    console.log(this.qrcode)
    if (this.upgrade){
      this.cloudbedService.getUpSells({reservationId: this.reservationNumber}).then(upgrades => {
        console.log(upgrades)
        this.upgradeList = upgrades;
        this.upgradeType = 1;
      })
    }
  }

  getUpsells(){
    return this.upgradeList.filter(obj => obj.categoryId == this.upgradeType).sort((a, b) => a.displayOrder - b.displayOrder)
  }

  callback(value: any){
    console.log(value)
    this.modalCtrl.dismiss({value});
  }

  continue(value: any){
    console.log(value)
    this.modalCtrl.dismiss({value});
    // this.router.navigate(['/welcome-checkin/scanid'])
  }
}
